export class ErrorWithCommandHelp extends Error {
}
